module.exports = __webpack_public_path__ + "img/27.3595826a.jpg";